
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import RadioButton from '@/components/radio-button.vue'
	import PageFooter from '@/components/page-footer.vue';
	import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue';
	import {
		getAgentCheckOrderList,
		checkBackendAgentOrder,
		checkBackendAgentOrderReject,
		getAgentOrderSummary,
		ordercheckOrderProductCollectSpecList
	} from '@/api/order';
	import {
		grade
	} from '@/utils/config'
	import {
		handleClipboard
	} from '@/utils/clipboard'
	import {
		nextDay
	} from "@/utils"

	const todayTimeStamp = new Date().toLocaleDateString().replace(/\//g,'-')
	const todayEndTime = new Date().toLocaleDateString().replace(/\//g,'-')

	@Component({
		name: 'agency_check-order',
		components: {
			RadioButton,
			PageFooter,
			'slz-dialog': Dialog,
			'slz-message': Message
		}
	})
	export default class AgencyCheckOrder extends Vue {
		private userId: number = +this.$route.query.id
		private list: any = [1]
		private selectIds: number[] = []
		private agencyKey = ''
		private keyword = ''
		private filterTime: any = ''
		// [todayTimeStamp, todayEndTime]
		private checked = true
		private radioType = 0;
		private pageNo = 1;
		private pageSize = 9999999;
		private total = 0;
		private totalProductNum = 0;
		private totalPrice = 0;
		private totalPostage = 0;
		private rejectReason = ''
		private rejectId = 0;
		private showCheckBox = false;
		private passWarn = '';
		private showWarn = false;
		private passTypeWarn = 0;
		private radioList: any = [{
				label: '待审核',
				value: 0
			}, {
				label: '已审核',
				value: 1
			}, {
				label: '已驳回',
				value: 2
			}
		];
		private showGoodsTotal = false
		private info: any = {}
		private roleConfig = grade
		private summaryTotal: number = 0
		private filter: number = 0

		private totalMoney = 0;
		private totalFreight = 0;
		private checkLoading = false;

		private showError = false;
		private errorList = [];

		private summary:any = []
		private tableloading=false

		private mounted() {
			this.filterTime = String(this.$route.query.filterTime).split('/')
			this.getList()
			this.handleShowGoods()
		}

		get dataList(){
			let list = [];
			if (this.radioType === 0){
				list = this.list.slice((this.pageNo-1)*this.pageSize, (this.pageNo-1)*this.pageSize+this.pageSize);
			}else{
				list = this.list;
			}
			return list
		}

		/**
		 * @func 选择订单
		 */
		private handleSelectionChange(val: any) {
			this.selectIds = []
			if (val.length) {
				for (let i = 0; i < val.length; i++) {
					this.selectIds.push(val[i].OrderNo)
				}
			}
		}

		private async handleShowGoods() {
			let params: any = {
				MemberId: this.userId,
				CheckState: this.radioType,
				Keywords: this.keyword
			}
			if (this.filterTime && this.filterTime.length) {
				params.AddStartTime = this.filterTime[0];
				params.AddEndTime = nextDay(this.filterTime[1],1);
			}
			try {
				const res: any = await getAgentOrderSummary(params)
				this.info = res.Result;
				// this.showGoodsTotal = true;

				this.getsummarylist(this.info.Results)

				this.totalMoney = this.info.ProductMoneyAll.toFixed(2);
				this.totalFreight = this.info.FreightMoneyAll.toFixed(2);
				// console.log(this.info)
			} catch (err) {
				console.log(err)
			}
		}

		private getsummarylist(list){
			this.summary = list.map(v=>{
				v.IsOpen  = false
				v.Open = false
				v.Id=v.ProductId+Math.random()
				v.Ismain = true
				return v
			})
		}

		private getrowkey(row){
			// console.log(row)
			return row.Id
		}

		private handleClickRow(scope){
			// console.log(scope)
			// scope.row.Open = !scope.row.Open
			if(scope.row.Open){
				this.$nextTick(()=>{
					const $table: any = this.$refs.table
					$table.toggleRowExpansion(scope.row)
					scope.row.Open = !scope.row.Open
				})
				return
			}
			this.getdetail(scope)

		}

		private async getdetail(scope){
			try{
				let msg = await scope
				let params:any = {
					ProductId:msg.row.ProductId,
					SpecValue:msg.row.SpecValue,
					SubmitterPrice:msg.row.SubmitterPrice,
					MemberId: this.userId,
					CheckState: this.radioType,
					Keywords: this.keyword
				}
				if (this.filterTime && this.filterTime.length) {
					params.AddStartTime = this.filterTime[0];
					params.AddEndTime = nextDay(this.filterTime[1],1);
				}
				let res = await ordercheckOrderProductCollectSpecList(params)
				if(res.IsSuccess){
					this.summary = this.summary.map(v=>{
						if(v.ProductId==scope.row.ProductId&&v.SubmitterPrice==scope.row.SubmitterPrice&&v.SpecValue==scope.row.SpecValue){
							v.ProductSpecSellStatisList = res.Result.map(x=>{
								x.Id=v.ProductId+Math.random()
								return x
							})
						}
						return v
					})
					this.$nextTick(()=>{
						const $table: any = this.$refs.table
						$table.toggleRowExpansion(scope.row)
						scope.row.Open = !scope.row.Open
					})
				}
			}finally{
				//
			}
		}


		private toCopy(event) {
			// console.log(event)
			let text = ''
			text += this.info.Name + '-' + this.info.RoleName +
				'交单(公司)\n';
			if (this.info && this.info.Results) {
				for (let key in this.info.Results) {
					let item = this.info.Results[key]
					text += (item.ProductName+' * '+item.ProductCount+' = '+item.SubmitterPrice+' * '+item.ProductCount+' = '+' 总价 ¥'+item.ProductMoney+'\n')
				}
			}
			text += ('特殊地区运费     ¥' + (this.info.FreightMoneyAll) + '\n');
			text += ('总金额          ¥' + (this.info.ProductMoneyAll+this.info.FreightMoneyAll).toFixed(2) +
				'\n');
			handleClipboard(text, event)
		}

		/**
		 * @func 组装复制内容
		 */
		private copyText(list) {
			let product = {}
			for (let i = 0; i < list.length; i++) {
				if (product[list[i].product_id]) {
					product[list[i].product_id].count += list[i].num
					product[list[i].product_id].price += list[i].price
					product[list[i].product_id].postage += list[i].postage
					if (product[list[i].product_id].skus[list[i].sku_id]) {
						let data = product[list[i].product_id].skus[list[i].sku_id]
						data.num += list[i].num
						data.total += list[i].price
					} else {
						product[list[i].product_id].skus[list[i].sku_id] = {
							price: parseInt(list[i].price / list[i].num + ''),
							params: list[i].params,
							num: list[i].num,
							total: list[i].price
						}
					}

				} else {
					product[list[i].product_id] = {
						count: list[i].num,
						price: list[i].price,
						name: list[i].product_name,
						postage: list[i].postage,
						skus: {}
					}
					product[list[i].product_id].skus[list[i].sku_id] = {
						price: parseInt(list[i].price / list[i].num + ''),
						params: list[i].params,
						num: list[i].num,
						total: list[i].price
					}
				}
			}
			if (JSON.stringify(product) === '{}') {
				return null
			} else {
				this.summaryTotal = 0
				for (let k in product) {
					console.log(k)
					this.summaryTotal += product[k].count
				}
				return product
			}
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList()
			this.handleShowGoods()
		}

		private clearSearch() {
			this.pageNo = 1;
			this.agencyKey = ''
			this.keyword = ''
			this.filterTime = String(this.$route.query.filterTime).split('/');
			this.getList()
			this.handleShowGoods()
		}

		private doPass(id: number) {
			this.doCheck([id], 1)
		}

		private doReject(id: number) {
			this.rejectId = id;
			this.showCheckBox = true;
		}

		private doSelectPass(type: number) {
			if (type === 1) {
				this.passWarn = '确认通过选择的订单？';
				this.showWarn = true;
				this.passTypeWarn = type;
			} else if (type === 2) {
				this.passWarn = '确认通过当前所有的订单？';
				this.showWarn = true;
				this.passTypeWarn = type;
			}
		}

		private handleConfirm() {
			if (this.passTypeWarn === 1) {
				if (!this.selectIds.length) {
					this.$message('请选择订单');
					return false;
				}
				this.doCheck(this.selectIds, 1)
			} else if (this.passTypeWarn === 2) {
				let list = this.list.map(item=>{
					return item.OrderNo;
				})
				if (!list.length) {
					this.$message('暂无可操作订单');
					return false;
				}
				this.doCheck(list, 3)
			}
		}

		private confirm() {
			if (!this.rejectReason) {
				this.$message('请输入驳回原因');
				return;
			}
			this.doCheck([this.rejectId], 2)
		}

		private cancel() {
			this.rejectReason = '';
			this.showCheckBox = false;
		}

		private toDetail(id: number) {
			this.$router.push({
				name: 'Order_Detail',
				query: {
					id: id + ''
				}
			})
		}

		private changePage(num: number) {
			this.pageNo = num;
			if (this.radioType !== 0){
				this.getList();
				this.handleShowGoods()
			}
		}

		private clickCheck(id: number) {
			let index: number = this.selectIds.indexOf(id);
			if (index !== -1) {
				this.selectIds.splice(index, 1);
			} else {
				this.selectIds.push(id)
			}
		}

		private async getList() {
			let params: any = {
				MemberId: this.userId,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				CheckState: this.radioType,
				Keywords: this.keyword
			}

			if (this.filterTime && this.filterTime.length) {
				params.AddStartTime = this.filterTime[0];
				params.AddEndTime = nextDay(this.filterTime[1],1);
			}
			try {
				this.tableloading = true
				const res: any = await getAgentCheckOrderList(params);
				this.total = res.Result.Total;
				this.list = res.Result.Results.map(v=>{
					v.namedisplay = v.ProductNameList.join(';')
					return v
				});
				this.selectIds = [];

				// let totalMoney = 0;
				// let totalFreight = 0;
				// res.Result.Results.map(item=>{
				// 	totalMoney += item.SubmitterProductMoney;
				// 	totalFreight += item.FreightMoney;
				// })

				// this.totalMoney = +totalMoney.toFixed(2);
				// this.totalFreight = +totalFreight.toFixed(2);
			} catch (e) {
				console.log(e)
			} finally{
				this.tableloading = false
			}
		}

		private async doCheck(ids: number[], state: number) {
			let params: any = {
				MemberId: this.userId,
				OrderNoList: ids,
				state: state,
				RejectReason: this.rejectReason
			}
			// if (state === 3 && this.filterTime && this.filterTime.length) {
			// 	params.start_time = parseInt(this.filterTime[0] / 1000 + '')
			// 	params.end_time = parseInt(this.filterTime[1] / 1000 + '')
			// }
			// if (state === 3 && this.agencyKey) {
			// 	if (this.list.length > 0) {
			// 		params.order_id = [this.list[0].order_id]
			// 		params.state = 1
			// 	} else {
			// 		this.$message('暂无订单，无法审核！');
			// 		return false;
			// 	}
			// }
			try {
				console.log(state)

				let loading:any = null;
				if(state == 3){
					loading = this.$loading({
						lock: true,
						text: '',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)',
						target: '#checkAllBtn'
					});
				}

				let res:any = {};
				if (state === 2){
					res = await checkBackendAgentOrderReject(params)
				}else{
					res = await checkBackendAgentOrder(params)
				}
				
				if (res.Result && res.Result.length){
					this.showError = true;
					this.errorList = res.Result;
				}

				this.$message({
					type: 'success',
					message: '已处理'
				})
				if (loading){
					loading.close();
				}
				
				this.pageNo = 1;
				this.getList();
				this.handleShowGoods()
				this.showCheckBox = false
				this.cancel()
			} catch (e) {
				console.log(e)
			}
		}

		changeList() {
			this.pageNo = 1;
			if (this.radioType===0){
				this.pageSize = 9999999;
			}else{
				this.pageSize = 10;
			}
			this.getList()
			this.handleShowGoods()
		}
	}
